import { i18n } from '@/plugins/i18n'

export const signType = {
    DIGITAL: 1,
    SMS: 2,
}

export const signTypeStr = {
    DIGITAL: i18n.t('online_contract.sign_types.digital'),
    SMS: i18n.t('online_contract.sign_types.sms'),

    get(type) {
        let type_str = null;

        Object.keys(signType).forEach(item => {
            if (signType[item] === type) {
                type_str = signTypeStr[item];
            }
        });

        return type_str;
    }
}